import { Injectable, inject } from '@angular/core';
import { Action, Selector, State } from '@ngxs/store';
import type { StateContext } from '@ngxs/store';
import type { INews } from '../../../shared/interfaces/INews';
import { NewsService } from '../../../shared/services/news.service';
import { LoadNews } from './news.actions';
import { from, Observable, finalize, tap } from 'rxjs';

export interface NewsStateModel {
    isLoading: boolean;
    news: INews[];
    loadedLanguage: string | null;
}

@State<NewsStateModel>({
    name: 'newsState',
    defaults: {
        isLoading: false,
        news: [],
        loadedLanguage: null
    }
})
@Injectable()
export class NewsState {
    private readonly newsService = inject(NewsService);

    @Selector()
    static isLoading(state: NewsStateModel): boolean {
        return state.isLoading;
    }

    @Selector()
    static news(state: NewsStateModel): INews[] {
        return state.news;
    }

    @Selector()
    static loadedLanguage(state: NewsStateModel): string | null {
        return state.loadedLanguage;
    }

    @Action(LoadNews)
    public loadNews(ctx: unknown, action: { payload: { lang: string } }): Observable<INews[]> {
        const stateContext = ctx as StateContext<NewsStateModel>;
        const { payload } = action;
        stateContext.patchState({ isLoading: true });

        return from(this.newsService.getNewsData()).pipe(
            tap(news => {
                stateContext.patchState({
                    news,
                    loadedLanguage: payload.lang
                });
            }),
            finalize(() => {
                stateContext.patchState({ isLoading: false });
            })
        );
    }
}
